import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Button from '../Elements/Button/Button';
import Input from '../Elements/Input/Input';
import { subscribeKlaviyo } from '../../actions/environment';
import { purifier } from '../../utils/dom';
import { translate } from '../../utils/locale';
import s from './Newsletter.scss';

const Newsletter = ({ setup, properties, newsletter = {}, footer = false, callback = false, ...props }) => {
	const [email, updateEmail] = useState('');
	const [status, updateStatus] = useState(false);

	const submitNewsletterHandler = (e) => {
		e.preventDefault();

		updateStatus('sent');
		updateEmail('');
		document.activeElement.blur();
		props.subscribeKlaviyo(email)
			.then(() => {
				if (callback) callback();

				window.setTimeout(() => {
					updateStatus(false);
				}, 3000);

				return 'sent';
			})
			.catch((err) => {
				console.log('DEBUG: err', err);
				updateStatus('error');
				return 'error';
			});
	};

	const newsletterInputChangeHandler = (id, value) => {
		updateEmail(value);
		updateStatus(false);
	};

	return (
		<div className={[s.newsletter, (status === 'sent' ? s.newsletter__sent : null), (footer ? s.newsletter__footer : null)].join(' ')}>
			<div className={s.newsletter_info} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, newsletter.info)) }} />
			<form className={[s.newsletter_form, (status === 'error' ? s.newsletter_form__error : null)].join(' ')} onSubmit={submitNewsletterHandler}>
				<Input id="newsletterFooter" type="email" value={email} inputChange={newsletterInputChangeHandler} />
				<Button variantClasses={['button__newsletter']} type="submit" text={translate(setup, newsletter.button)} />
			</form>
			<span className={s.newsletter_thanks}>{translate(setup, newsletter.thanks)}</span>
		</div>
	);
};

const mapState = ({ environment }, { callback }) => ({
	setup: environment.setup,
	newsletter: environment.newsletter,
	properties: environment.properties,
	callback,
});

export default hot(module)(connect(mapState, { subscribeKlaviyo })(Newsletter));
